import axios from 'axios';

import { SellerSettings } from '../../../../../enums/seller-settings/seller-settings';
import { UserSettings } from '../../../../../enums/user-settings/user-settings';
import { updateSellerSettingsBulk, updateUserSettingsBulk } from '../../../api/save-settings';
import { getCurrentDateTimeAsUtcIso } from '../../../../../services/datetime-service';

export const updateSellerPhone = (phoneNumber: string = ''): Promise<void> => {
  return axios.post('/seller/updatePhone', { phoneNumber });
};

export const persistPhoneLastUpdatedUtc = async (): Promise<void> => {
  await updateSellerSettingsBulk({
    [SellerSettings.phoneLastUpdatedUtc.key]: getCurrentDateTimeAsUtcIso(),
  });
  await updateUserSettingsBulk({
    [UserSettings.phoneNumberCaptureBannerDismissed.settingName]: false,
  });
};
